/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type PaginationResponse from "./PaginationResponse";
import type PendingSubmissionQueryLeaf from "./PendingSubmissionQueryLeaf";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type SubmissionDisplayLeaf from "./SubmissionDisplayLeaf";
import type Void from "./Void";
import type ManualSubmissionRequest from "./ManualSubmissionRequest";
import type Data from "./Data";
import type IdRequest from "./IdRequest";
import type ManualJobRequest from "./ManualJobRequest";
import type PreReportData from "./PreReportData";
import type SubmissionReportDataLeafResponseApi from "./SubmissionReportDataLeafResponseApi";
import type IdsRequest from "./IdsRequest";
import type MfwSuccess from "./MfwSuccess";
import type File from "./File";
import type ReportDataResultLeaf from "./ReportDataResultLeaf";
import type UpdateReportDataRequestLeaf from "./UpdateReportDataRequestLeaf";
import type SubmissionDataResponse from "./SubmissionDataResponse";
import type PrepareSubmissionLeaf from "./PrepareSubmissionLeaf";
import type DataRequest from "./DataRequest";
import type SampleBlock from "./SampleBlock";
import type ManualFileSubmissionRequest from "./ManualFileSubmissionRequest";
import type ReportDataRequest from "./ReportDataRequest";

const urls = {
    exportResultsLeaf(request: IdRequest): string {
        return queryUrl("/api/submission/exportresultsleaf", request);
    },
    exportResultsFarmerSample(request: IdRequest): string {
        return queryUrl("/api/submission/exportresultsfarmersample", request);
    },
    downloadDocument(fileId: number, submissionId: number): string {
        return queryUrl("/api/submission/downloaddocument", {fileId, submissionId});
    },
    questPdf(leafIds: number[]): string {
        return queryUrl("/api/submission/questpdf", {leafIds});
    },
    questImage(submissionId: number, leafId: number, recommendation: string, whatDoesPlantSay: string): string {
        return queryUrl("/api/submission/questimage", {submissionId, leafId, recommendation, whatDoesPlantSay});
    }
}

export default {
    urls,
    paged(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<PendingSubmissionQueryLeaf>>> {
        return Axios.post("/api/submission/paged", request, defaultConfig);
    },
    pagedCompleted(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplayLeaf>>> {
        return Axios.post("/api/submission/pagedcompleted", request, defaultConfig);
    },
    pagedResults(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplayLeaf>>> {
        return Axios.post("/api/submission/pagedresults", request, defaultConfig);
    },
    pagedArchived(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplayLeaf>>> {
        return Axios.post("/api/submission/pagedarchived", request, defaultConfig);
    },
    pagedWaiting(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplayLeaf>>> {
        return Axios.post("/api/submission/pagedwaiting", request, defaultConfig);
    },
    getSampleNumbersForSubmission(submissionId: number): Promise<AxiosResponse<string[]>> {
        return Axios.post("/api/submission/getsamplenumbersforsubmission", submissionId, defaultConfig);
    },
    updateManualSubmission(request: ManualSubmissionRequest): Promise<AxiosResponse<Void>> {
        return Axios.post("/api/submission/updatemanualsubmission", request, defaultConfig);
    },
    getResults(request: IdRequest): Promise<AxiosResponse<Data[]>> {
        return Axios.post("/api/submission/getresults", request, defaultConfig);
    },
    manualLabId(request: ManualJobRequest): Promise<AxiosResponse<boolean>> {
        return Axios.post("/api/submission/manuallabid", request, defaultConfig);
    },
    exportResultsLeaf(request: IdRequest): Promise<AxiosResponse> {
        return Axios.get(queryUrl("/api/submission/exportresultsleaf", request), defaultConfig);
    },
    exportResultsFarmerSample(request: IdRequest): Promise<AxiosResponse> {
        return Axios.get(queryUrl("/api/submission/exportresultsfarmersample", request), defaultConfig);
    },
    preReport(request: IdsRequest): Promise<AxiosResponse<PreReportData<SubmissionReportDataLeafResponseApi>>> {
        return Axios.post("/api/submission/prereport", request, defaultConfig);
    },
    postToMfw(request: IdRequest): Promise<AxiosResponse<MfwSuccess[]>> {
        return Axios.post("/api/submission/posttomfw", request, defaultConfig);
    },
    downloadDocument(fileId: number, submissionId: number): Promise<AxiosResponse> {
        return Axios.get(queryUrl("/api/submission/downloaddocument", {fileId, submissionId}), defaultConfig);
    },
    getDocs(request: IdRequest): Promise<AxiosResponse<File[]>> {
        return Axios.post("/api/submission/getdocs", request, defaultConfig);
    },
    print(request: IdRequest): Promise<AxiosResponse<string>> {
        return Axios.post("/api/submission/print", request, defaultConfig);
    },
    updateReportData(reports: UpdateReportDataRequestLeaf[]): Promise<AxiosResponse<ReportDataResultLeaf[]>> {
        return Axios.post("/api/submission/updatereportdata", reports, defaultConfig);
    },
    prepareSubmission(request: DataRequest): Promise<AxiosResponse<SubmissionDataResponse<PrepareSubmissionLeaf>>> {
        return Axios.post("/api/submission/preparesubmission", request, defaultConfig);
    },
    getSamplesBlocksLeaf(request: IdRequest): Promise<AxiosResponse<SampleBlock[]>> {
        return Axios.post("/api/submission/getsamplesblocksleaf", request, defaultConfig);
    },
    getSamplesBlocksFarmerSample(request: IdRequest): Promise<AxiosResponse<SampleBlock[]>> {
        return Axios.post("/api/submission/getsamplesblocksfarmersample", request, defaultConfig);
    },
    updateSampleBlockNamesLeaf(request: SampleBlock[]): Promise<AxiosResponse> {
        return Axios.post("/api/submission/updatesampleblocknamesleaf", request, defaultConfig);
    },
    updateSampleBlockNamesFarmerSample(request: SampleBlock[]): Promise<AxiosResponse> {
        return Axios.post("/api/submission/updatesampleblocknamesfarmersample", request, defaultConfig);
    },
    questPdf(leafIds: number[]): Promise<AxiosResponse> {
        return Axios.get(queryUrl("/api/submission/questpdf", {leafIds}), defaultConfig);
    },
    uploadManualSubmissionFiles(request: ManualFileSubmissionRequest): Promise<AxiosResponse<Void>> {
        return Axios.post("/api/submission/uploadmanualsubmissionfiles", toFormData(request), defaultFormConfig);
    },
    questImage(submissionId: number, leafId: number, recommendation: string, whatDoesPlantSay: string): Promise<AxiosResponse> {
        return Axios.get(queryUrl("/api/submission/questimage", {submissionId, leafId, recommendation, whatDoesPlantSay}), defaultConfig);
    },
    delete(request: IdRequest): Promise<AxiosResponse<boolean>> {
        return Axios.post("/api/submission/delete", request, defaultConfig);
    },
    submit(request: ReportDataRequest<PrepareSubmissionLeaf>): Promise<AxiosResponse<ReportDataRequest<PrepareSubmissionLeaf>>> {
        return Axios.post("/api/submission/submit", request, defaultConfig);
    },
    archiveLeafs(request: IdsRequest): Promise<AxiosResponse> {
        return Axios.post("/api/submission/archiveleafs", request, defaultConfig);
    },
    archive(request: IdRequest): Promise<AxiosResponse> {
        return Axios.post("/api/submission/archive", request, defaultConfig);
    },
    restore(request: IdRequest): Promise<AxiosResponse> {
        return Axios.post("/api/submission/restore", request, defaultConfig);
    }
}
